import { render, staticRenderFns } from "./TheProvince.vue?vue&type=template&id=5995d1ae&scoped=true"
import script from "./TheProvince.vue?vue&type=script&lang=ts"
export * from "./TheProvince.vue?vue&type=script&lang=ts"
import style0 from "./TheProvince.vue?vue&type=style&index=0&id=5995d1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995d1ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheSelect: require('/usr/src/nuxt-app/components/core/select/TheSelect.vue').default})
